import * as React from 'react'
// components
import TableRow from '@mui/material/TableRow'
import { HoverablePopover } from 'components/UI'
// types
import { Modals } from 'constants/modals'
import { ISecurityProfile } from 'types/graphql'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// views
import { EllipsizedText } from 'themes/views/generic'
import { CheckedIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'
// utils
import moment from 'moment'

interface Props {
  data: ISecurityProfile
}

const Row: React.FC<Props> = ({ data }) => {
  const { showModal } = useShowModal({ modalType: Modals.SECURITY_PROFILE_MODAL })

  const { id, name, active, createdAt } = data

  const showProfileModal = () => showModal({ profile: data, isEdit: true })

  return (
    <TableRow hover>
      <TableCell size={20}>
        <HoverablePopover
          trigger={
            <EllipsizedText
              data-testid='security-profile'
              data-entity-id={id}
              onClick={showProfileModal}
              style={TEXT_STYLE}>
              {name}
            </EllipsizedText>
          }>
          {name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{moment(createdAt).format('DD/MM/Y')}</TableCell>
      <TableCell size={5}> {active && <CheckedIcon />}</TableCell>
    </TableRow>
  )
}

export default Row
